module.exports = __webpack_public_path__ + "img/icon_result.0e61fe50.png";